import { render } from "./ExperimentCard.vue?vue&type=template&id=1c04653a&scoped=true"
import script from "./ExperimentCard.vue?vue&type=script&lang=js"
export * from "./ExperimentCard.vue?vue&type=script&lang=js"

import "./ExperimentCard.vue?vue&type=style&index=0&id=1c04653a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c04653a"]])

export default __exports__